import "./ContactReserveSession.module.css";
import Encabezado from "@/reusable_sections/Header";
import HeroDeContacto from "./sections/HeroDeContacto";
import FormularioDeContacto from "./sections/FormularioDeContacto";
import ContactInformation from "./sections/ContactInformation";
import PieDePA_gina from "@/reusable_sections/Footer";
export default function ContactReserveSessionPage() {
  return <div>
      <Encabezado />
      <HeroDeContacto />
      <FormularioDeContacto />
      <ContactInformation />
      <PieDePA_gina />
    </div>;
}